import styled from 'styled-components';
import { rem } from 'polished';
var Spacer = styled.span.withConfig({
  displayName: "Spacerstyles__Spacer",
  componentId: "sc-y7r12c-0"
})(["width:", ";min-width:", ";height:", ";min-height:", ";display:", ";background:", ";"], function (props) {
  return rem(props.width);
}, function (props) {
  return rem(props.width);
}, function (props) {
  return rem(props.height);
}, function (props) {
  return rem(props.height);
}, function (props) {
  return props.display;
}, function (props) {
  return props.color ? props.color : 'transparent';
});
export var Styled = {
  Spacer: Spacer
};